import { ChangeDetectorRef, Component, HostListener, OnDestroy } from '@angular/core';
import { Subscription } from 'rxjs';
import { TerminalsService } from '../../../services/terminals.service';

// @@angularMigrate
@Component({
    templateUrl: './actions-data.component.html',
    standalone: false
})

export abstract class ActionsBase implements OnDestroy {

  @HostListener('document:keydown', ['$event']) onKeydownHandler(event: KeyboardEvent) {
    if (event.key === 'Escape') {
      // console.log("escape base!", event);
      this.cancel();
      event.preventDefault();
    }

    if (event.ctrlKey && event.key == 's') {
      // console.log("strg + s save!");
      if (this.isSaveable()) {
        this.savePerson();
      }
      event.preventDefault();
    }

    if (event.ctrlKey && event.key == 'e') {
      console.log("strg + e verwerfen!");
      this.discardChanges();
      event.preventDefault();
    }

  }

  public subscriptions: Subscription[] = new Array<Subscription>();

  abstract discardChanges();
  abstract isSaveable();
  abstract savePerson();
  abstract cancel();
  abstract updateData();

  constructor(public cdr: ChangeDetectorRef, private manageService: TerminalsService) { }

  ngAfterViewInit(): void {
    if (this.manageService) {
      this.subscriptions.push(this.manageService.isSavedSuccess.subscribe(res => {
        this.cdr.detectChanges();
      }));

      this.subscriptions.push(this.manageService.isdiscardChanged.subscribe(res => {
        this.cdr.detectChanges();
      }));

      this.subscriptions.push(this.manageService._model.subscribe(res => {
        this.cdr.detectChanges();
      }));

      this.subscriptions.push(this.manageService.isEditModeChanged.subscribe(res => {
        this.cdr.detectChanges();
      }));
    }
  }

  ngOnDestroy(): void {
    for (let subscription of this.subscriptions) {
      if (subscription) {
        subscription.unsubscribe();
      }
    }
  }

  public get planning(): boolean {
    return false;
  }

  public get isTemplateMenuVisible() {
    return false;
  }

  get canDelete(): boolean {
    return false;
  }

  get canCreate(): boolean {
    return false;
  }

  get isOld(): boolean {
    return false;
  }

  get isWorking(): boolean {
    return false;
  }
}
